import { render, staticRenderFns } from "./help-button.vue?vue&type=template&id=023dbb43&"
import script from "./help-button.vue?vue&type=script&lang=js&"
export * from "./help-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/galexp/development/web/educraft-vue-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023dbb43')) {
      api.createRecord('023dbb43', component.options)
    } else {
      api.reload('023dbb43', component.options)
    }
    module.hot.accept("./help-button.vue?vue&type=template&id=023dbb43&", function () {
      api.rerender('023dbb43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/help-button.vue"
export default component.exports